import { createMuiTheme } from '@material-ui/core/styles';
import primary from '@material-ui/core/colors/yellow';
import secondary from '@material-ui/core/colors/blueGrey';



const main1 = "black";// "#53d8fd";
const main2 = "rgb(212, 198, 180)";
const orange = "#ffc700";
interface IColors {
    header: IBackground;
    footer: IFooter;
    bullet: IBackground;
    body: IBackground;

}
interface IHover {
    hoverColor: string;
}
interface ILink extends IHover {
    color: string;
}
interface IFooter extends IBackground {
    link: ILink;
    chevron: { bgColor: string, ringColor: string, hoverColor: string }
    copyright: { color: string, bgColor: string, icon: { bgColor: string }, link: ILink }
}
export interface IBackground {
    color: string;
    bgColor: string;
}

export const colors: IColors = {
    header: {
        bgColor: main1,
        color: "white",
    },
    footer: {
        bgColor: main1,
        color: "white",
        link: {
            color: "white",
            hoverColor: "#eee",

        },
        chevron: {
            bgColor: "white",
            ringColor: orange,
            hoverColor: main2,

        },
        copyright: {
            color: "#4c4c4c",
            bgColor: main1,
            icon: {
                bgColor: "gray",
            },
            link: {
                color: "#777",
                hoverColor: "#eee",

            },
        }

    },
    bullet: {
        color: main2,
        bgColor: main1,
    },
    body: {
        color: main1,
        bgColor: orange,
    }
}

export const theme = createMuiTheme({



});


// WEBPACK FOOTER //
// ./src/theme.ts